import { WifiOff } from "lucide-react";
import { useNetworkStatus } from "@/hooks/use-network-status";

export function NetworkStatusBanner() {
  const isOnline = useNetworkStatus();

  if (isOnline) return null;

  return (
    <div className="border-b border-warning/20 bg-warning/5 px-4 py-2 dark:border-warning/30 dark:bg-warning/20">
      <div className="flex items-center justify-center gap-2 text-warning-foreground dark:text-warning-foreground">
        <WifiOff className="size-4" />
        <p className="text-sm font-medium">
          You're currently offline. Some features may not work.
        </p>
      </div>
    </div>
  );
}
